<header>
    <!-- TOP HEADER -->
    <div id="top-header">
        <div class="container">
            <ul class="header-links pull-left">
                <li><a class="white-anchor" href="tel:0860747877"><i class="fa fa-phone"></i> Sales Support: (0860)
                        747-877</a></li>
            </ul>
            <ul class="header-links pull-right">

                <li><a href="https://sacoronavirus.co.za/" target="_blank">Stay informed! Visit the SA Department of
                        Health's website for COVID-19 updates: www.sacoronavirus.co.za</a></li>
            </ul>
        </div>
    </div>
    <div id="header-two">
        <div class="container">
            <ul class="header-two pull-left">
                <li><a class="header-two" [routerLink]="['/contact']">CONTACT</a> | </li>
                <!-- <li><a class="header-two" [routerLink]="['/']">HELP</a> | </li> -->
                <span *ngIf="!hasValidToken; else elseBlock">
                    <li><a class="header-two" [routerLink]="['/register-account']"> REGISTER</a> | </li>
                    <li><a class="header-two" [routerLink]="['/login']"> LOGIN</a> | </li>
                </span>
                <ng-template #elseBlock>
                    <li><button (click)="logout()" class="header-two"> LOGOUT</button> | </li>
                    <li><a class="header-two" [routerLink]="['/orders-history']"> ORDERS</a> | </li>
                    <li><a class="header-two" [routerLink]="['/access-to-information']"> ACCOUNT</a> | </li>
                    <li><a [routerLink]="['/access-to-information']"><span class="header-two">
                            </span>{{decodedToken?.firstName}} {{decodedToken?.surname}}</a> | </li>
                </ng-template>
                <li style="margin-left: 0px;">
                    <a href="https://api.whatsapp.com/send?phone=27648101077"><i class="fa fa-whatsapp"></i> Chat on
                        WhatsApp</a>
                </li>

            </ul>



            <!-- {{(len$ | async).wishlistItems.lssssssength}} -->
            <div class="header-ctn">
                <!-- Wishlist -->
                <div *ngIf="hasValidToken"> <a [routerLink]="['/wish-list']"> <i class="fa fa-heart-o"></i>
                        <span>Your Wishlist</span>
                        <div *ngIf="noOfItemsWishlist" class="qty"> {{(noOfItemsWishlist | async) ?? 0}} </div>
                    </a> </div>
                <!-- /Wishlist -->
                <!-- Cart -->

                <div *ngIf="hasValidToken" class="dropdown">
                    <a class="dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                        <i class="fa fa-shopping-cart"></i> <span>Your Cart</span>
                        <div *ngIf="noOfItems" class="qty"> {{(noOfItems | async) ?? 0}}</div>
                    </a>


                    <div class="cart-dropdown" data-keyboard="False">
                        <div *ngIf="cart" class="cart-list">


                            <div class="product-widget" *ngFor="let product of cart.cartItems">


                                <div class="product-img">
                                    <img src={{product.imageUrl}} alt="">
                                </div>
                                <div class="product-body">



                                    <h3 class="product-name"><a
                                            [routerLink]="['/products',product.productId]" [queryParams]="{subCategory: product.subCategory, category: product.category}">{{product.productDescription}}</a>
                                    </h3>
                                    <!-- <h4 class="product-price"><span class="qty">{{product.quantity}}</span>{{product.listPriceincl*product.quantity  | currency:'R' | amountFormat}}</h4> -->
                                    <h4 class="product-price"><span
                                            class="qty">{{product.quantity}}</span>{{product.totalPriceIncl |
                                        currency:'R' | amountFormat}}</h4>
                                </div>
                                <button class="delete" (click)="removeFromCart(product)"><i
                                        class="fa fa-close"></i></button>
                            </div>

                        </div>

                        <div class="cart-summary"> <small>{{(noOfItems | async)}} Item(s) selected</small>
                            <h5>TOTAL: {{(totalPrice | async) | currency:'R' | amountFormat }} </h5>
                        </div>
                        <div class="cart-btns">
                            <a [routerLink]="['/cart']">View Cart</a>
                            <a [routerLink]="cart?.cartItems?.length === 0 ? null : ['/checkout']"
                                [class.disabled]="cart?.cartItems?.length === 0 ? true : false">Checkout <i
                                    class="fa fa-arrow-circle-right"></i></a>
                        </div>
                    </div>
                </div>
                <!-- /Cart -->
                <!-- Menu Toogle mobile -->
                <!-- Menu Toggle mobile -->
                <div class="menu-toggle">
                    <a (click)="openMenu($event)" routerLink="/">
                        <i class="fa fa-bars"></i>
                        <span>Menu</span>
                    </a>
                </div>
                <!-- /Menu Toggle mobile -->

                <!-- Menu content -->
                <div class="menu-content">
                    <!-- Your menu items go here -->
                </div>

                <!-- /Menu Toogle mobile -->
            </div>
        </div>
    </div>

    <!-- /TOP HEADER -->

    <!-- MAIN HEADER -->
    <div id="headerthree">
        <!-- container -->
        <div class="container">
            <!-- row -->
            <div class="row">
                <!-- LOGO -->
                <div class="col-md-3">
                    <div class="header-logo">
                        <a routerLink="/" class="logo">
                            <img src="../../../../assets/images/sv-logo-png.png" alt="">
                        </a>
                    </div>
                </div>
            </div>
            <!-- /LOGO -->


            <!-- row -->
        </div>
        <!-- container -->
    </div>
    <!-- /MAIN HEADER -->
</header>




<app-nav [searchText]="searchText$ | async"></app-nav>
<app-breadcrumb-footer></app-breadcrumb-footer>
